import { ApolloClient, InMemoryCache, HttpLink } from "@apollo/client";

const baseURL = `${process.env.NEXT_PUBLIC_ACKO_DRIVE_CATALOG_SERVICE}/graphql`;
// or import GRAPHQL_URL

const client = new ApolloClient({
  link: new HttpLink({
    uri: `${baseURL}`,
    fetch,
  }),
  cache: new InMemoryCache({
    addTypename: false,
  }),
  defaultOptions: {
    watchQuery: { fetchPolicy: "no-cache" },
    query: { fetchPolicy: "no-cache" },
  },
});

export default client;
